import React from "react"
import styles from "./tag.module.scss"
import { Link } from "gatsby"

export default (props) => (
  <Link className={styles.tagLink} to={"/tags/" + props.tag}>
    <h4 className={styles.tag}>#{props.tag}</h4>
  </Link>
)
